var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuItemTasksManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.571 9.07h0l-4.125 4.126h0a.187.187 0 01-.062.04l.192.463-.192-.462a.187.187 0 01-.143 0l-.192.462.192-.462a.186.186 0 01-.061-.04v-.001l-2.063-2.063a.19.19 0 01-.041-.06l-.457.188.457-.189a.189.189 0 01.04-.205l-.32-.32.32.32a.187.187 0 01.206-.041c.023.01.044.023.061.04l1.576 1.578.353.354.354-.354 3.638-3.64h0a.187.187 0 01.205-.04l.192-.463-.192.462c.023.01.044.023.061.04l.001.002a.187.187 0 010 .265z",
    fill: "#ED1B2E",
    stroke: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125.5h13.75a2.25 2.25 0 012.25 2.25v16.5a2.25 2.25 0 01-2.25 2.25H4.125a2.25 2.25 0 01-2.25-2.25v-.875h.375v.875a1.875 1.875 0 001.875 1.875h13.75a1.875 1.875 0 001.875-1.875V2.75A1.875 1.875 0 0017.875.875H4.125A1.875 1.875 0 002.25 2.75v.875h-.375V2.75A2.25 2.25 0 014.125.5z",
    fill: "#ED1B2E",
    stroke: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 7.375h.5V6.187a.187.187 0 11.375 0v1.188h1.188a.187.187 0 110 .375H.688a.187.187 0 01-.133-.32l-.347-.347.347.347a.187.187 0 01.132-.055h.688zm0 4.125h.5v-1.188a.188.188 0 01.375 0V11.5h1.188a.188.188 0 010 .375H.688a.188.188 0 010-.375h.687zm0 4.125h.5v-1.188a.188.188 0 01.375 0v1.188h1.188a.188.188 0 010 .375H.688a.188.188 0 010-.375h.687z",
    fill: "#ED1B2E",
    stroke: "#ED1B2E"
  })));
}

export default SvgIconMenuItemTasksManagement;